import OrderSellerRemarksFlag from "@/enum/OrderSellerRemarksFlag";

const SellerRemarkFlagImgUrlMapping = {
    [OrderSellerRemarksFlag.RED]: "https://img.alicdn.com/imgextra/i2/54458674/O1CN01tPr4l22DwkR63Nn06_!!54458674.png",
    [OrderSellerRemarksFlag.YELLOW]:
        "https://img.alicdn.com/imgextra/i4/54458674/O1CN01uCcPWH2DwkRGD6his_!!54458674.png",
    [OrderSellerRemarksFlag.GREEN]:
        "https://img.alicdn.com/imgextra/i3/54458674/O1CN01JKYRWI2DwkRFGIlJa_!!54458674.png",
    [OrderSellerRemarksFlag.BLUE]: "https://img.alicdn.com/imgextra/i3/54458674/O1CN01SMNzpG2DwkR63Of2l_!!54458674.png",
    [OrderSellerRemarksFlag.PURPLE]:
        "https://img.alicdn.com/imgextra/i3/54458674/O1CN01RZvZPU2DwkR63Oauv_!!54458674.png",
    [OrderSellerRemarksFlag.ORANGE]:
        "https://img.alicdn.com/imgextra/i3/54458674/O1CN01TENoOg2DwkRDIiI2V_!!54458674.png",
    [OrderSellerRemarksFlag.LIGHT_BLUE]:
        "https://img.alicdn.com/imgextra/i4/54458674/O1CN01CYdJ8k2DwkRE697AY_!!54458674.png",
    [OrderSellerRemarksFlag.PEACH]:
        "https://img.alicdn.com/imgextra/i1/54458674/O1CN01vO7hOn2DwkRDevsiX_!!54458674.png",
    [OrderSellerRemarksFlag.PINK]: "https://img.alicdn.com/imgextra/i3/54458674/O1CN012ObuOV2DwkRDIil8R_!!54458674.png",
    [OrderSellerRemarksFlag.DARK_GREEN]:
        "https://img.alicdn.com/imgextra/i1/54458674/O1CN01ScuwGl2DwkREojige_!!54458674.png",
};

export default SellerRemarkFlagImgUrlMapping;
